import { setErrorMessage, setShowErrorMessage } from "app/system/errors/ServerErrorAlertSlice";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "setup/appInsights/ApplicationInsightsService";
import { CPLErrorTypes } from "cpl-react-common/Helpers/CustomErrors";
import { setErrorCode } from "app/modules/errors/ErrorHandlerSlice";
import { isRejectedWithValue } from "@reduxjs/toolkit";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export const errorMiddleWare =
  ({ dispatch }: { dispatch: (arg0: any) => any }) =>
  (next: (arg0: { type: string }) => any) =>
  (action: { type: string; payload: any; error?: any }) => {
    try {
      if (action.error) {
        if (!isRejectedWithValue(action)) {
          let errorType = action.error.message;
          try {
            const parsed = JSON.parse(action.error.message);
            if (parsed?.message) {
              errorType = parsed.message;
            }
          } catch {
            // response body isn't JSON - compare as-is
          }

          switch (errorType) {
            case CPLErrorTypes.NOT_FOUND:
              dispatch(setErrorCode(404));
              break;
            case CPLErrorTypes.FORBIDDEN:
              dispatch(setErrorCode(403));
              break;
            default:
              dispatch(setErrorMessage(action.error.message));
              dispatch(setShowErrorMessage(true));
              break;
          }
        }
        appInsights.trackException({ error: new Error(action.error), severityLevel: SeverityLevel.Error });
      }
      return next(action);
    } catch (err: any) {
      appInsights.trackException({ error: new Error(err), severityLevel: SeverityLevel.Error });
      dispatch(setErrorMessage("Oh no, we broke :( Please let us know"));
      dispatch(setShowErrorMessage(true));
      throw err;
    }
  };
